// $scope.sections = nsSections.create();
import angular from 'angular';
import {RunConfigService} from '@nuskin/ns-util';
import {ShippingAddress, ErrorMessageCookieService, CartService} from '@nuskin/ns-shop';

angular.module('checkout').factory('nsSections', ['nsSection', function(nsSection) {
    'use strict';

    return {
        create: function() {
            // ---------------------------------------------
            //
            //        Constructor
            //
            // ---------------------------------------------
            const sections = {
                initialized: false,
                general: new nsSection(),
                cart: new nsSection(),
                shipping: new nsSection(),
                shipmethod: new nsSection(),
                payment: new nsSection(),
                adrOptions: new nsSection(),
                review: new nsSection()
            };

            sections.general.error = ErrorMessageCookieService.getErrorMessages();

            sections.cart.keepOpen = false;

            sections.cart.modified = false;

            sections.shipping.newAddress = new ShippingAddress();
            sections.shipping.newAddress.setShippingCountry(RunConfigService.getRunConfig().country);
            sections.shipping.editAddress = {};
            sections.shipping.saveToProfile = true;
            sections.shipping.beShippingAddressId = 1;

            sections.shipmethod.showPickUpPerson = false;

            // ---------------------------------------------
            //
            //        Public Methods
            //
            // ---------------------------------------------

            //  readyToOrder returns true if we are ready to call sap to create order
            sections.readyToOrder = function(isBusy) {
                // Make sure all sections are dirty, no simulate is occuring, there aren't any validation errors,
                // payment and shipping address are selected, and the cart has no pending changes
                return !sections.review.pristine &&
                    !sections.cart.pristine &&
                    !sections.shipping.pristine &&
                    !sections.shipmethod.pristine &&
                    !sections.shipmethod.edit &&
                    !isBusy &&
                    sections.shipping.isSelected() &&
                    !sections.cart.modified &&
                    !sections.adrOptions.edit;
            };

            sections.hasErrorMessages = function() {
                return sections.cart.error.hasErrorsWhichMustBeResolved() ||
                    sections.shipping.error.hasErrorsWhichMustBeResolved() ||
                    sections.shipmethod.error.hasErrorsWhichMustBeResolved() ||
                    sections.review.error.hasErrorsWhichMustBeResolved();
            };

            sections.clearErrors = function() {
                sections.general.error.clearErrors();
                sections.cart.error.clearErrors();
                sections.shipping.error.clearErrors();
                sections.shipmethod.error.clearErrors();
                sections.payment.error.clearErrors();
                sections.review.error.clearErrors();
            };

            sections.openErrorSections = function() {
                if (sections.hasErrorMessages()) {
                    sections.closeSections();
                    if (sections.cart.error.hasErrorMessages()) {
                        sections.cart.edit = true;
                        sections.cart.pristine = false;
                    } else if (sections.shipping.error.hasErrorMessages()) {
                        sections.shipping.edit = true;
                        sections.shipping.pristine = false;
                    } else if (sections.shipmethod.error.hasErrorMessages()) {
                        sections.shipmethod.edit = true;
                        sections.shipmethod.pristine = false;
                    } else if (sections.review.error.hasErrorMessages()) {
                        sections.review.pristine = false;
                    }
                }
            };

            sections.closeSections = function() {
                sections.cart.edit = false;
                sections.shipping.edit = false;
                sections.shipmethod.edit = false;
                sections.payment.edit = false;
                sections.adrOptions.edit = false;
            };

            // Open the correct initial section depending on fast checkout.
            sections.initializeSections = function(needToSelectPickupLocation, hasPaymentPref = false) {
                const hasRedeemedItems = CartService.getItemData({sapItems: true}).some((item) => item.redeem);

                // Open cart section if order contains one or more redeemed items
                if (hasRedeemedItems) {
                    sections.cart.edit = true;
                    sections.cart.pristine = false;
                    sections.payment.pristine = false;
                    sections.shipping.pristine = false;
                    if (needToSelectPickupLocation) {
                        sections.shipmethod.pristine = true;
                    } else {
                        sections.shipmethod.pristine = false;
                    }
                    // If they need to select a pickup location then open the shipmethod section
                } else if (needToSelectPickupLocation) {
                    sections.cart.pristine = false;
                    sections.shipping.pristine = false;
                    sections.shipmethod.pristine = false;
                    sections.shipmethod.edit = true;
                    sections.payment.pristine = false;
                } else {
                    // Open the payment section so they can enter the cvv
                    sections.cart.pristine = false;
                    sections.shipping.pristine = false;
                    sections.shipmethod.pristine = false;
                    sections.payment.edit = false;
                    sections.review.pristine = !hasPaymentPref;
                    sections.payment.pristine = false;
                }
                sections.openErrorSections();
                sections.initialized = true;
            };

            ErrorMessageCookieService.resetErrorMessagesStorage();

            return sections;
        }
    };
}]);
